// assignmentSheet.styles.js — 배정 상세·마케터 고르기·급여 조건 창 공용 스타일 (2026-10-06)
//   휴대폰 손가락 기준: 주요 버튼 44px, 목록 줄 48px 이상(가로 넘침 없음).
export const SH = {
  wrap: { display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 },
  summary: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: 12,
    background: 'var(--bg-subtle)',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 0,
  },
  nameRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, minWidth: 0 },
  name: { fontSize: 16, fontWeight: 900, color: 'var(--text)', minWidth: 0, wordBreak: 'keep-all' },
  line: { display: 'flex', gap: 8, fontSize: 13, color: 'var(--text-sub)', lineHeight: 1.5, minWidth: 0 },
  lineKey: { flex: '0 0 72px', color: 'var(--text-muted)', fontWeight: 700 },
  lineVal: { minWidth: 0, flex: 1, wordBreak: 'keep-all', overflowWrap: 'anywhere', color: 'var(--text)', fontWeight: 700 },
  hint: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.55 },
  lockHint: {
    fontSize: 12,
    lineHeight: 1.5,
    color: '#b45309',
    background: 'rgba(245,158,11,0.10)',
    border: '1px solid rgba(245,158,11,0.25)',
    borderRadius: 10,
    padding: '8px 10px',
  },
  actions: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 },
  actionBtn: {
    minHeight: 48,
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: '8px 10px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    fontSize: 14,
    fontWeight: 800,
    cursor: 'pointer',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  actionSub: { fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', lineHeight: 1.35 },
  dangerBtn: {
    alignSelf: 'flex-start',
    minHeight: 40,
    border: 'none',
    background: 'transparent',
    color: '#dc2626',
    fontSize: 13,
    fontWeight: 800,
    padding: '6px 2px',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  search: {
    height: 44,
    width: '100%',
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '0 12px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
  },
  list: { display: 'flex', flexDirection: 'column', gap: 6 },
  pickRow: {
    minHeight: 48,
    width: '100%',
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '8px 12px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    textAlign: 'left',
    boxSizing: 'border-box',
  },
  pickName: { fontSize: 14, fontWeight: 800, color: 'var(--text)' },
  pickMeta: { fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' },
  empty: { padding: 16, textAlign: 'center', fontSize: 13, color: 'var(--text-muted)' },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 8 },
  badge: (tone) => ({
    flex: '0 0 auto',
    borderRadius: 999,
    padding: '3px 9px',
    background: tone === 'active' ? 'rgba(22,163,74,0.12)' : tone === 'upcoming' ? 'rgba(37,99,235,0.12)' : 'rgba(100,116,139,0.12)',
    color: tone === 'active' ? '#15803d' : tone === 'upcoming' ? '#2563eb' : '#64748b',
    fontSize: 12,
    fontWeight: 800,
    whiteSpace: 'nowrap',
  }),
};
